// MemberList.jsx
import React, { useEffect, useState } from "react";
import { fetchWorkspaceMembersForAdmin, updateMemberStatus  } from "../../api/api";
import "./MemberList.css";

const MemberList = ({ workspace_id, refresh }) => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (!workspace_id) return;

    const loadMembers = async () => {
      try {
        const data = await fetchWorkspaceMembersForAdmin(workspace_id);
        setMembers(data.members || []);
      } catch (err) {
        console.error(err);
      }
    };

    loadMembers();
  }, [workspace_id, refresh]);

  const getRoleBadgeClass = (role) => {
    switch (role?.toLowerCase()) {
      case 'admin':
        return 'role-badge role-admin';
      case 'viewer':
        return 'role-badge role-viewer';
      default:
        return 'role-badge role-member';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'status-badge status-active';
      case 'inactive':
        return 'status-badge status-inactive';
      case 'pending':
        return 'status-badge status-pending';
      default:
        return 'status-badge status-unknown';
    }
  };

  const formatStatusText = (status) => {
    if (!status) return 'Unknown';
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const toggleStatus = async (member) => {
    const newStatus = member.status === "active" ? "inactive" : "active";
    await updateMemberStatus(member.id, newStatus);
    setMembers((prev) =>
      prev.map((m) =>
        m.id === member.id ? { ...m, status: newStatus } : m
      )
    );
  };

  return (
    <div className="members-table-container">
      <div className="table-wrapper">
        <table className="members-table">
          <thead>
            <tr>
              <th className="table-header">Name</th>
              <th className="table-header">Email</th>
              <th className="table-header">Role</th>
              <th className="table-header">Status</th>
              <th className="table-header">Action</th>
            </tr>
          </thead>
          <tbody>
            {members.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  <div className="empty-content">
                    <svg className="empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <p className="empty-text">No members found</p>
                    <p className="empty-subtext">Invite members to get started</p>
                  </div>
                </td>
              </tr>
            ) : (
              members.map((member) => (
                <tr key={member.id} className="table-row">
                  <td className="table-cell name-cell">
                    <div className="member-info">
                      {member.name || 'Unnamed User'}
                    </div>
                  </td>
                  <td className="table-cell email-cell">
                    {member.email}
                  </td>
                  <td className="table-cell role-cell">
                    <span className={getRoleBadgeClass(member.role)}>
                      {member.role || 'Member'}
                    </span>
                  </td>
                  <td className="table-cell status-cell">
                    <span className={getStatusBadgeClass(member.status)}>
                      {formatStatusText(member.status)}
                    </span>
                  </td>
                  <td className="table-cell">
                    <button
                      className={`status-btn ${member.status}`} // active → Deactivate, inactive → Activate
                      onClick={() => toggleStatus(member)}
                    >
                      {member.status === "active" ? "Deactivate" : "Activate"}
                    </button>
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MemberList;